import {ServerTranslation} from 'constants/SequenceConstants';
import {CDSCoordinates} from 'import-sequence/ImportSequenceConstants';
import {CRISPRUserSettings} from 'molbio/crispr/CRISPRDefaults';
import * as net from 'util/Net';
import {OngoingTaskResponse} from 'util/TaskRunner';

interface ScoreGuidesData extends CRISPRUserSettings {
  sequenceIds: Array<string>;
  startTime: string;
  name: string;
}

export function scoreGuides(data: ScoreGuidesData): JQueryPromise<OngoingTaskResponse> {
  return net.postJSON({
    url: '/1/api/batch-guide-design/actions/score-guides',
    data,
  });
}

export interface CRISPRStatsSequence {
  id: string;
  name: string;
  numCrisprAnalyses: number;
  translations: Array<ServerTranslation>;
}
export interface CheckCRISPRStatsResponse {
  sequences: Array<CRISPRStatsSequence>;
}

export function checkSequenceCRISPRStats(data: {
  sequenceIds: Array<string>;
}): JQueryPromise<CheckCRISPRStatsResponse> {
  return net.postJSON({
    url: '/1/api/batch-guide-design/actions/check-sequence-crispr-stats',
    data,
  });
}

export interface ExportGuidesSequenceInfo {
  sequenceName: string;
  cdsCoords: Array<CDSCoordinates>;
  exonNames: Array<string>;
  cdsPercentage: number | null;
}

interface ExportGuidesData {
  sequenceIds: Array<string>;
  numGuidesPerExon: number;
  minOffTargetScore: number;
  minOnTargetScore: number;
  cdsPercentage: number;
  startTime: string;
  sequenceInfos: Array<ExportGuidesSequenceInfo>;
}

export function exportGuides(data: ExportGuidesData): JQueryPromise<OngoingTaskResponse> {
  return net.postJSON({
    url: '/1/api/batch-guide-design/actions/export-guides',
    data,
  });
}
